<mat-form-field class="dict-registrations">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="registrationFilterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono rejestracji">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let registration of items"
                [value]="registration.uuid">
      {{registration.insuranceCompany.name}} {{registration.ofwca.fullName}}  {{rau? ' ,'  + (registration.ofwca?.rauNumbers[0]? registration.ofwca?.rauNumbers[0]?.rau : 'brak RAU' ): ''}} {{status? ' (Status: ' +  registration.status?.name + ')' : ''}} {{regional? ' (' +  registration.assetsRegional?.fullName + ')' : ''}} {{company? ' ' +  registration.contract?.company?.name + '' : ''}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
